import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { IconButton } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import DeleteIcon from '@mui/icons-material/Delete'

import * as HrActions from '../../../store/actions/hr.action'
import Services from '../../../shared/services'
import ConfirmationModal from '../../../shared/components/ui/modal/confirmation-modal'
import { IColumnActionProps } from '../../../shared/interfaces/datagrid.interface'
import { IHrDelete } from '../../../shared/interfaces/hr.interface'

const HrActionButton = ({ slug, status }: IColumnActionProps) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [data, setData] = useState({
    slug: '',
    remarks: '',
  })

  useEffect(() => {
    if (data.slug) {
      dispatch(HrActions.HrDeleteApplication(data))
      setModalOpen(false)
    }
  }, [data])

  const onModalAction = (e: string, remarks?: string) => {
    if (e === 'confirm') {
      if (remarks) {
        setData((prev: IHrDelete) => {
          return {
            ...prev,
            slug: slug,
            remarks: remarks,
          }
        })
      } else Services.toast('error', 'Remarks is required')
    } else {
      setModalOpen(false)
    }
  }

  const onClickHandler = () => {
    navigate(`/hr/${slug}/information`)
  }

  const onDeleteHandler = () => {
    setModalOpen(true)
  }

  return (
    <>
      <IconButton color='primary' sx={{ mr: '.25rem' }} onClick={onClickHandler}>
        <VisibilityIcon />
      </IconButton>

      {status !== 'finalized' && (
        <IconButton color='primary' sx={{ mr: '.25rem' }} onClick={onDeleteHandler}>
          <DeleteIcon />
        </IconButton>
      )}

      <ConfirmationModal
        isModalOpen={modalOpen}
        title={'Confirmation'}
        message={'Do you want to delete this application?'}
        isRemarks={true}
        onClickModal={(e: string, remarks?: string) => onModalAction(e, remarks)}
      />
    </>
  )
}

export default HrActionButton
